import dayjs from "dayjs";
import { saveAs } from "file-saver";
import _ from "lodash";
import * as XLSX from "xlsx";

// import { formatDuration } from "./formatDuration";

export const handleExportOverview = async ({ data }) => {
  const formattedData = _.map(data, (item) => {
    const rawStartDate = _.get(item, ["start_date"]);
    const sDate = dayjs(rawStartDate).format("DD/MM/YYYY HH:mm:ss");
    const rawEndDate = _.get(item, ["end_date"]);
    const eDate = dayjs(rawEndDate).format("DD/MM/YYYY HH:mm:ss");
    // const totalDuration = _.get(item, ["total_duration"]);
    // const formatTotalDuration = formatDuration({ seconds: totalDuration });
    return {
      "Media Name": _.get(item, ["media_name"]),
      "Screen Name": _.get(item, ["device_name"]),
      "Start Date": sDate,
      "End Date": eDate,
      "Total Duration (Seconds)": _.get(item, ["total_duration"]),
      Times: _.get(item, ["times"]),
      "Total Days": _.get(item, ["total_days"]),
    };
  });

  const suffixName = dayjs().format("DD-MM-YYYY-HH-mm-ss");
  const fileName = `overview_${suffixName}.xlsx`;
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Overview");

  worksheet["!cols"] = [
    { wch: 30 },
    { wch: 25 },
    { wch: 20 },
    { wch: 20 },
    { wch: 20 },
    { wch: 10 },
    { wch: 10 },
  ];

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, fileName);
};
